// import components
import PeriodSelector from './PeriodSelector';
import ActionToExecute from './ActionToExecute';
import HoursBalanceImport from './HoursBalanceImport';
import {
  StyledDrawerContentBox,
  StyledWideDrawer
} from '../Servicedesk.styles';

// import hooks
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import type { ServicedeskProcedureDrawerProps } from '../Servicedesk.types';

const ServicedeskProcedureDrawer = ({
  procedureCode,
  onClose
}: ServicedeskProcedureDrawerProps) => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null
  ]);

  // This component itself never unmounts, unlike PeriodSelector/ActionToExecute below (which
  // only render while procedureCode is set): without this, dateRange survives a close and the
  // next open renders ActionToExecute with the previous period already selected while
  // PeriodSelector, being freshly mounted, visually shows nothing picked.
  useEffect(() => {
    if (!procedureCode) {
      setDateRange([null, null]);
    }
  }, [procedureCode]);

  const renderContent = () => {
    if (procedureCode === 'IMPORT_HOURS_BALANCE') {
      return <HoursBalanceImport />;
    }

    return (
      <>
        <PeriodSelector onChange={setDateRange} />
        {procedureCode && (
          <ActionToExecute
            procedureCode={procedureCode}
            startDate={dateRange[0]}
            endDate={dateRange[1]}
          />
        )}
      </>
    );
  };

  return (
    <StyledWideDrawer
      open={!!procedureCode}
      onClose={onClose}
      title={
        procedureCode
          ? t(`adminPortal.servicedesk.procedures.${procedureCode}.name`)
          : ''
      }
    >
      {procedureCode && (
        <StyledDrawerContentBox>{renderContent()}</StyledDrawerContentBox>
      )}
    </StyledWideDrawer>
  );
};

export default ServicedeskProcedureDrawer;
